import { HttpInterceptorFn } from '@angular/common/http';
import { MOCK_HANDLERS } from './mock.registry';
export const MockInterceptor: HttpInterceptorFn = (req, next) => {
    const handler = MOCK_HANDLERS.find((h) => h.matches(req));
    if (handler) {
        return handler.handle(req);
    }
    return next(req);
};
